import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/icons/payment-success.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "payment__successful tw-text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "payment_success_icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("h4", { class: "tw-mt-8 tw-text-xl tw-tracking-[0.15px] tw-leading-6 tw-font-bold tw-text-[#0C0F4A]" }, " Payment Successful "),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0C0F4A] tw-mt-5" }, [
    /*#__PURE__*/_createTextVNode(" Congratulations! 🥳 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Your project is ready to go ")
  ])
], -1)
const _hoisted_2 = { class: "tw-w-full tw-grid tw-items-center" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ContractSignYellowIcon from "@/core/components/icons/ContractSignYellowIcon.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessModal',
  emits: ["on-close", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const onCloseModal = () => {
  emits("on-close");
};

const onConfirm = () => {
  emits("on-save");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "",
    onOnClose: onCloseModal,
    width: "350px",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          label: "done",
          onClick: onCloseModal,
          variant: "accent"
        })
      ])
    ]),
    _: 1
  }))
}
}

})